import { Box } from 'aos-ui-universal'
import React, { ReactNode } from 'react'

interface TaskFormLayoutProps {
    main: ReactNode
    sidebar: ReactNode
}

export const TaskFormLayout = ({ main, sidebar }: TaskFormLayoutProps) => (
    <Box className='h-full w-full flex-row'>
        <Box className='flex-1 gap-6 overflow-auto bg-background-surface px-8 py-7'>{main}</Box>
        <Box className='w-[320px] gap-6 overflow-auto bg-background-sub-surface p-6'>{sidebar}</Box>
    </Box>
)
